module.exports = __webpack_public_path__ + "static/media/Brocheta.e1fc98a0.jpg";